<template>
  <validation-provider v-slot="{ errors }"
                       :name="name"
                       :class="{ 'textarea_focused': isFocused, 'textarea_disabled': disabled, 'textarea_has-value': hasValue, 'textarea_resize': resize }"
                       :rules="validate"
                       tag="div"
                       class="textarea">

    <div class="textarea-header"
         :class="{ 'textarea-header_has-error': !!errors.length }">
      <div class="textarea-header-left">
        <div class="textarea-header-label">{{label ? `${label} ${ isRequired ? '*' : '' }` : undefined}}</div>

        <i v-if="help"
           v-tooltip="help"
           class="mdi mdi-help-circle-outline pointer textarea-header-help"></i>
      </div>

      <slot name="header-right" />
    </div>

    <v-textarea class="textarea-input"
                :class="{ 'textarea-input_has-error': !!errors.length }"
                v-model="intervalVal"
                :disabled="disabled"
                :error-messages="errors"
                :counter="counter"
                :minlength="minlength"
                :maxlength="maxlength"
                :rows="rows"
                @input="emitVal"
                @focus="setFocus"
                @blur="unsetFocus">
    </v-textarea>
  </validation-provider>
</template>
 
<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
  },

  data() {
    return {
      intervalVal: this.value,
      isFocused: false,
    };
  },

  computed: {
    hasValue() {
      return !!this.intervalVal;
    },
    isRequired() {
      return this.validate && this.validate.includes("required");
    },
  },

  watch: {
    value: function (val) {
      this.intervalVal = val;
    },
  },

  props: {
    validate: {
      Type: String,
    },
    name: {
      Type: String,
    },
    label: {
      Type: String,
    },
    value: {
      Type: String,
    },
    disabled: {
      Type: Boolean,
    },
    help: {
      type: String,
    },
    counter: {
      type: Number,
      default: 160,
    },
    minlength: {
      type: Number,
    },
    maxlength: {
      type: Number,
    },
    rows: {
      type: Number,
    },
    resize: {
      type: Boolean,
      default: true,
    },
  },

  mixins: [],

  mounted() {
    if (this.value) {
      this.intervalVal = this.value;
    }
  },

  methods: {
    emitVal(newVal) {
      this.$emit("input", newVal);
    },
    setFocus() {
      this.isFocused = true;
    },
    unsetFocus() {
      this.isFocused = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.textarea {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 6px; 

  ::v-deep textarea {
    resize: none;
  }

  .textarea-help {
    color: #707070;
  }

  .textarea-header {
    display: flex;
    justify-content: space-between;
    padding: 0;

    .textarea-header-left {
      display: flex;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      transform-origin: bottom left;
      margin-bottom: 5px;

      .textarea-header-label {
        color: rgba(0, 0, 0, 0.54);
        margin-right: 5px;
        font-size: 16px;
      }

      .textarea-header-help {
        color: rgba(0, 0, 0, 0.54);

        &:hover {
          color: $green-dark;
        }
      }

      &.textarea-header_has-error {
        .textarea-header-label,
        .textarea-header-help {
          color: #ff4141;
        }
      }
    }
  }

  .textarea-input {
    outline: solid 1px rgba(0, 0, 0, 0.42);
    transition: 0.3s linear;
    border-radius: 20px;
    padding: 15px;    

    ::v-deep .v-input__slot {
      &::before {
        border: none;
      }
      &::after {
        border: none;
      }
    }

    ::v-deep .v-text-field__details {
      .v-counter {
        display: none;
      }
    }

    ::v-deep textarea {
      color: #4d4d4d !important;
    }

    &.v-input--is-focused {
      outline-width: 2px;
      outline-color: $primary;
    }

    &.textarea-input_has-error {
      outline-color: #ff4141;
    }
  }

  &.textarea_focused {
    .textarea-header {
      .textarea-header-left {
        transform: scale(0.75);

        &:not(.textarea-header_has-error) {
          .textarea-header-label,
          .textarea-header-help {
            color: $primary;
          }
        }
      }
    }
  }

  &.textarea_disabled {
    .textarea-header {
      .textarea-header-label {
        color: rgba(0, 0, 0, 0.38);
      }
    }

    .textarea-input {
      outline: dotted 1px rgba(0, 0, 0, 0.38);

      ::v-deep textarea {
        color: rgba(0, 0, 0, 0.38) !important;
      }
    }
  }

  &.textarea_has-value {
    .textarea-header {
      .textarea-header-left {
        transform: scale(0.75);
      }
    }
  }

  &.textarea_resize {
    ::v-deep textarea {
      resize: both;
    }
  }
}
</style>
